module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"widgets.conversationGiftsPopup.widget":[{"value":"ConversationGiftsPopup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"@root","_fox_":1}],"widgets.conversationGiftsPopup.widgets.giftBoxBody.giftType":[{"value":"conversation","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"@root","_fox_":1}],"widgets.conversationGiftsPopup.widgets.giftBoxBody.giftPaymentSuccess":[{"value":"inboxSocketEventConversation:giftUnlock","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101015},"path":"@root","_fox_":1}],"widgets.conversationGiftsPopup.widgets.giftBoxBody.targetIdCb":[{"value":function () {
return fox.getEnv('site.conversationId');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/conversationGiftsPopup.js
// module id = 685
// module chunks = 4